import { render } from "./productsPage.vue?vue&type=template&id=f4a0e8ec&scoped=true"
import script from "./productsPage.vue?vue&type=script&lang=js"
export * from "./productsPage.vue?vue&type=script&lang=js"

import "./productsPage.vue?vue&type=style&index=0&id=f4a0e8ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a0e8ec"]])

export default __exports__